import styles from './NoSupplierPermission.css'
import { NothingBlock } from './YCard'

const NoSupplierPermission = () => (
  <NothingBlock
    className={styles.noPermission}
    iconType='ec-block-people'
    text='您無該供應商之權限'
  />
)

export default NoSupplierPermission
